import { render, staticRenderFns } from "./pageGradeList.vue?vue&type=template&id=156a484a&scoped=true"
import script from "./pageGradeList.vue?vue&type=script&lang=js"
export * from "./pageGradeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156a484a",
  null
  
)

export default component.exports